





























import { defineComponent, ref } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { Follower, InputFollowingsSearch } from "@scrile/api-provider/dist/api/FollowingsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import QuickTipsItem from "@/components/QuickTipsItem";
import FollowingItem from "./FollowingItem.vue";

export default defineComponent({
  name: "NotificationsFollowingsList",
  components: {
    FollowingItem,
    EmptyContent,
    InfiniteScroll,
    QuickTipsItem,
    BaseSpinner,
  },
  setup() {
    const { authUserStrict } = useAuthUser();
    const loading = ref(false);
    const unfollowingUserIds = new Set<string>();

    const {
      enableScroll,
      items: followings,
      getFirstPage,
      getNextPage,
      updateItem,
      getLostItem,
    } = usePager<Follower, InputFollowingsSearch>(async (page, data) => {
      let response = await providers.FollowingsProvider.find({
        data: {
          page,
          followerId: authUserStrict.value.id,
          sort: "RECEIVE_SPECIAL_NOTIFICATION,DESC;TIME,DESC",
          ...data,
        },
      });
      if (unfollowingUserIds.size) {
        response = {
          ...response,
          result: response.result.filter(i => !unfollowingUserIds.has(i.userId)),
        };
      }
      return response;
    });

    const updateSpecialNotifications = debounce(async ({ following, cb }: { following: Follower; cb: () => void }) => {
      try {
        const updatedFollowing = await providers.FollowingsProvider.update({
          data: {
            userId: following.userId,
            followerId: following.followerId,
            receiveSpecialNotifications: !following.receiveSpecialNotifications,
          },
        });

        updateItem(updatedFollowing, i => i.userId === following.userId);

        if (following.receiveSpecialNotifications) {
          unfollowingUserIds.add(following.userId);
          await getLostItem(data => {
            const ids = followings.value.map(i => i.userId);
            return !data.result.some(i => ids.includes(i.userId));
          });
        } else {
          unfollowingUserIds.delete(following.userId);
        }
      } finally {
        cb();
      }
    }, 500);

    const getData = async () => {
      try {
        loading.value = true;
        await getFirstPage();
      } finally {
        loading.value = false;
      }
    };

    getData();
    return { loading, followings, getNextPage, enableScroll, updateSpecialNotifications };
  },
});
